import { SortDataArrays } from '@/src/types/flight'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../rootReducer'

export type SelectedSort = {
    sortKey: keyof SortDataArrays
    displayValue: string
}

interface SrpStates {
    selectedSort: SelectedSort[]
    recommendedFilter: {
        //nonStop handled in stopFilterManager
        checkedBaggageIncluded: boolean
        hideBudgetAirlines: boolean
    }[]
}

const initialState: SrpStates = {
    selectedSort: [
        { sortKey: 'price_up', displayValue: 'Cheapest' },
        { sortKey: 'price_up', displayValue: 'Cheapest' }
    ],

    recommendedFilter: [
        {
            checkedBaggageIncluded: false,
            hideBudgetAirlines: false
        },
        {
            checkedBaggageIncluded: false,
            hideBudgetAirlines: false
        }
    ]
}

export const srpSlice = createSlice({
    name: 'srp',
    initialState,
    reducers: {
        setOnwardSelectedSort: (state, action: PayloadAction<SelectedSort>) => {
            state.selectedSort[0] = action.payload
        },
        setReturnSelectedSort: (state, action: PayloadAction<SelectedSort>) => {
            state.selectedSort[1] = action.payload
        },

        setOnwardCheckedBaggageIncludedRecommendedFilter: (state, action: PayloadAction<boolean>) => {
            state.recommendedFilter[0].checkedBaggageIncluded = action.payload
        },
        setReturnCheckedBaggageIncludedRecommendedFilter: (state, action: PayloadAction<boolean>) => {
            state.recommendedFilter[1].checkedBaggageIncluded = action.payload
        },
        setOnwardHideBudgetAirlinesRecommendedFilter: (state, action: PayloadAction<boolean>) => {
            state.recommendedFilter[0].hideBudgetAirlines = action.payload
        },
        setReturnHideBudgetAirlinesRecommendedFilter: (state, action: PayloadAction<boolean>) => {
            state.recommendedFilter[1].hideBudgetAirlines = action.payload
        },
        resetRecommendedFilter: state => {
            state.recommendedFilter = initialState.recommendedFilter
        },
        resetOnwardRecommendedFilter: state => {
            state.recommendedFilter[0] = initialState.recommendedFilter[0]
        },
        resetReturnRecommendedFilter: state => {
            state.recommendedFilter[1] = initialState.recommendedFilter[1]
        },

        flushData: state => {
            return initialState
        }
    }
})

export const {
    setOnwardSelectedSort,
    setReturnSelectedSort,
    flushData,
    setOnwardCheckedBaggageIncludedRecommendedFilter,
    setReturnCheckedBaggageIncludedRecommendedFilter,
    setOnwardHideBudgetAirlinesRecommendedFilter,
    setReturnHideBudgetAirlinesRecommendedFilter,
    resetRecommendedFilter,
    resetOnwardRecommendedFilter,
    resetReturnRecommendedFilter
} = srpSlice.actions

export const getSelectedSort = (state: RootState) => state.srp.selectedSort
export const getRecommendedFilter = (state: RootState) => state.srp.recommendedFilter

export default srpSlice.reducer
